<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">门店详情</p>
		</sub-ibox-title>
		<section class="fx filter-list">
			<div class="fx fx-wrap fx-fill">
				<!--<p class="p-15">当前门店：111111</p>-->
			</div>
			<div class="fx fx-wrap fx-fill"></div>
			<!--<z-search v-model="params.search" placeholder="请输入红包名称..." @handleSearch="handleOffset(0)"></z-search>-->
		</section>
		<!--<section class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill">
				<div class="fx fx-wrap m-l-10">
					<el-date-picker
				      type="daterange"
				      align="left"
				      placeholder="选择日期范围(默认所有)">
				    </el-date-picker>
				</div>
			</div>
			<z-search placeholder="请输入微信昵称..."></z-search>
		</section>-->
		<z-table :offset="params.offset" :count="params.count" :total-count="shopEnvelopeRecordList.item_total" @handleOffset="handleInit">
			<th slot="columns" v-for="(index, item) in columns">
				{{index}}
			</th>
			<tr slot="datasource" v-for="item in shopEnvelopeRecordList.list || []">
				<td>{{item.nickname}}</td>
				<td><img :src="item.headimgurl" /></td>
				<td>{{item.total_fee | filterMoney}}</td>
				<td>{{item.pay_fee | filterMoney}}</td>
				<td>{{item.envelope_fee | filterMoney}}</td>
				<td>
					<span v-if="item.status == 1">已领取</span>
					<span v-else>已使用</span>
				</td>
				<td>{{item.l_time | momentFmt}}</td>
			</tr>
		</z-table>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	table img{
		width: 50px;
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1100px);
		}
	}
</style>
<script>
	import { mapState,mapActions } from 'vuex'
	export default {
		name: 'RedPacketManagePage',
		data() {
			return {
				columns: ['昵称', '头像', '订单金额', '支付金额', '红包金额', '状态', '修改时间'],
				params: {
					envelopeId: '',
					shopId: '',
					offset: 0,
					count: 10,
				}
			}
		},
		async mounted() {
			this.params.envelopeId = this.$route.query.envelopeId;
			this.params.shopId = this.$route.query.shopId;
			if (this.params.envelopeId && this.params.shopId) await this.handleInit();
		},
		computed: {
			...mapState({
				shopEnvelopeRecordList: state => state.envelope.shopEnvelopeRecordList
			})
		},
		methods: {
			async handleInit() {
				await this.getShopEnvelopeRecord(this.params);
			},
			...mapActions(['getShopEnvelopeRecord']),
	    }
	}
</script>



// WEBPACK FOOTER //
// RedPacketManagePage.vue?25595354